<app-splash-screen></app-splash-screen>
<div class="container" *ngIf="loading">
   <div class="spinner-border" style="color: #00118E;"></div>
</div>
<router-outlet>
</router-outlet>